module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/military-school-lvl1-50.2c00d20a.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/military-school-lvl1-50.png
// module id = 3544
// module chunks = 11